import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import PRICING from '../../config/pricing';

const PricingSection = ({ onStartTrial }) => {
  return (
    <section className="py-32 bg-white" id="pricing">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-serif text-3xl md:text-4xl text-stone-900 mb-8">
          Simple pricing
        </h2>

        <div className="flex items-baseline justify-center gap-2 mb-4">
          <span className="font-serif text-6xl text-stone-900">{PRICING.getDisplayRate()}</span>
          <span className="text-stone-500">per photo</span>
        </div>

        <p className="text-amber-600 text-sm font-medium mb-10">
          First {PRICING.getMaxFreePhotos()} photos free — no credit card required
        </p>

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-10">
          {[
            'AI-generated titles',
            'Rich descriptions',
            'Relevant tags & keywords',
            'Flickr, SmugMug & Unsplash',
          ].map((feature) => (
            <div key={feature} className="flex items-center gap-2 text-sm text-stone-600">
              <Check className="h-4 w-4 text-amber-500 flex-shrink-0" />
              {feature}
            </div>
          ))}
        </div>

        <button
          onClick={onStartTrial}
          className="bg-stone-900 text-white px-8 py-3.5 rounded font-medium hover:bg-stone-800 transition-colors inline-flex items-center group"
        >
          Start Free Trial
          <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
        </button>
      </div>
    </section>
  );
};

export default PricingSection;
